import { EPermission } from 'app/types/enums/EPermission';
import { useContext, useEffect, useState } from 'react';
import { PermissionContext } from './PermissionContext';

export const usePermission = (permission: EPermission) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState<boolean>();

  const { isAllowedTo } = useContext(PermissionContext);

  useEffect(() => {
    isAllowedTo(permission).then((_allowed) => {
      setLoading(false);
      setAllowed(_allowed);
    });
  }, [permission, isAllowedTo]);

  return [loading, allowed];
};
